<template>
  <BlockTitle :subtitle :title />
  <div class="flex grow justify-center">
    <YoutubeEmbedded
      class="rounded-lg flex overflow-hidden"
      :image
      :size
      :title
      :tracking
      :youtube-id
    />
  </div>
</template>

<script setup lang="ts">
import type { EmbeddedYoutubeVideoApiProps } from '@backmarket/http-api/src/api-specs-content/models/video'

import type { BlockProps } from '../../models/content-block'
import BlockTitle from '../../shared-components/BlockTitle/BlockTitle.vue'
import YoutubeEmbedded from '../../shared-components/YoutubeEmbedded/YoutubeEmbedded.vue'

export type EmbeddedYoutubeVideoBlockProps = EmbeddedYoutubeVideoApiProps &
  BlockProps

withDefaults(defineProps<EmbeddedYoutubeVideoBlockProps>(), {
  size: 'small',
})

// This event is common to every CMS block in order to hide the block containers
// on demand
defineEmits(['error', 'reset-error'])
</script>
